import React, { createContext, useContext, useEffect } from 'react';
import { useHttpRequest } from './HttpRequest';
import { useLocalStorage } from './useLocalStorage';
import { HTTP_METHODS } from 'src/config/constants';
import apiBase from 'src/config/apiBase';

const UserContext = createContext();

const UserProvider = ({ children }) => {

    const { isLoading, error, sendRequest, clearError } = useHttpRequest();

    const getUserList = async (filters) => {
        console.log("On getUserList");

        const requestBody = filters
        const headers = {
        }

        const responseData = await sendRequest(
            '/user/list',
            HTTP_METHODS.POST,
            headers,
            requestBody
        )
        return responseData
    }

    // const token = localStorage.getItem('token')
    // console.log("token",token);
    const createNewUser = async (data) => {
        console.log("On createNewUser");
        const headers = {
            'Content-Type': 'application/json',
        }

        const requestBody = {
            username: data.username,
            password: data.password,
            role: data.role,
            companyCode: data.companyCode,
            firstname: data.firstname,
            lastname: data.lastname,
            email: data.email,
            mobile: data.mobile
        }

        const responseData = await sendRequest(
            '/user/register',
            HTTP_METHODS.POST,
            headers,
            requestBody
        )
        console.log(responseData, "responseData");
        return responseData
    }

    const getUser = async (user_id) => {
        console.log("On getUser");
        const headers = {}

        const responseData = await sendRequest(
            `/user/${user_id}`,
            HTTP_METHODS.GET,
            headers
        )
        console.log(responseData, "dddd");
        return responseData
    }

    const updateUser = async (user_id, data) => {
        console.log("user_id", user_id, data);
        console.log("On updateUser");
        const headers = {
            'Content-Type': 'application/json',
        }

        const requestBody = {
            firstname: data.firstname,
            lastname: data.lastname,
            mobile: data.mobile,
            email: data.email,
            dob: data.dob,
            whatsapp: data.whatsapp,
            wechat: data.wechat,
        }

        const responseData = await sendRequest(
            `/user/${user_id}`,
            HTTP_METHODS.PUT,
            headers,
            requestBody
        )
        console.log(responseData);
        return responseData
    }

    const inactiveUser = async (user_id) => {
        const headers = {}

        const responseData = await sendRequest(
            `/user/${user_id}/inactive`,
            HTTP_METHODS.PUT,
            headers
        )
        return responseData
    }

    const activeUser = async (user_id) => {
        const headers = {}

        const responseData = await sendRequest(
            `/user/${user_id}/active`,
            HTTP_METHODS.PUT,
            headers
        )
        return responseData
    }

    const resertPassword = async (user_id, data) => {
        console.log("On resertPassword");
        const headers = {}

        const requestBody = {
            newPwd: data.password
        }

        const responseData = await sendRequest(
            `/user/${user_id}/reset-password`,
            HTTP_METHODS.PUT,
            headers,
            requestBody
        )
        console.log(responseData);
        return responseData
    }

    useEffect(() => {
    }, [])

    return (
        <UserContext.Provider value={{
            isLoading,
            error,
            clearError,
            getUserList,
            createNewUser,
            getUser,
            updateUser,
            inactiveUser,
            activeUser,
            resertPassword,
        }}>
            {children}
        </UserContext.Provider>
    );
}

const useUser = () => {
    const userContext = useContext(UserContext)
    return userContext
}

export { UserProvider, useUser }